import getAuditTrailParahubErrorDetail from '@hooks/parahub/getAuditTrailParahubErrorDetail';

const useGetAuditTrailParahubErrorDetail = (data) => {
    return getAuditTrailParahubErrorDetail({ enabled: data?.status === 'failed', id: data?.id });
};

export default useGetAuditTrailParahubErrorDetail;
